<mat-expansion-panel [expanded]="true" *ngIf="itemPresupuesto != null">
  <mat-expansion-panel-header class="card-header">
    <mat-panel-title class="text-style" click="onSearch()">
      <mat-icon style="margin-top: -3px;">assignment</mat-icon> Datos de Presupuesto
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-container *ngIf="canEdit">

    <div fxLayout="row stretch" fxLayout.xs="column">

      <form [formGroup]="formGroup">
        <div fxLayout="row stretch" fxLayout.xs="column">

          <div fxFlex=100 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <input type="text" placeholder="Proveedor*" aria-label="Proveedor" matInput [matAutocomplete]="proveedor"
                formControlName="Proveedor">
              <i [ngStyle]="{'display': isProveedorAutoSearching ? 'inline-block' : 'none'}"
                class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
                <mat-error *ngIf="!formGroup.controls['Proveedor'].valid && formGroup.controls['Proveedor'].touched">
                  {{ getErrorProveedor() }}
                </mat-error>
            </mat-form-field>
            <mat-autocomplete #proveedor="matAutocomplete" [displayWith]="displayProveedor">
              <mat-option *ngFor="let s of filteredProveedorList" [value]="s">
                {{s.RazonSocial }}
              </mat-option>
            </mat-autocomplete>
            
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isFormaPagoSearching">Formas de Pago*</mat-label>
              <mat-label *ngIf="isFormaPagoSearching">Cargando...</mat-label>
              <mat-select multiple formControlName="FormaPagoId">
                <mat-option *ngFor="let s of formaPagoList" [value]="s.Id">{{s.Nombre}}</mat-option>
              </mat-select>
              <mat-error *ngIf="!formGroup.controls['FormaPagoId'].valid  && formGroup.controls['FormaPagoId'].touched">
                {{ getErrorFormaPago() }}
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isTipoCompraSearching">Tipo de Compra*</mat-label>
              <mat-label *ngIf="isTipoCompraSearching">Cargando...</mat-label>
              <mat-select formControlName="TipoCompra">
                <mat-option *ngFor="let s of tipoCompraList" [value]="s.Id">{{s.Nombre}}</mat-option>
              </mat-select>
              <mat-error *ngIf="!formGroup.controls['TipoCompra'].valid && formGroup.controls['TipoCompra'].touched">
                {{ getErrorTipoCompra() }}
              </mat-error>
            </mat-form-field>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isMonedaSearching">Moneda*</mat-label>
              <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
              <mat-select formControlName="MonedaId">
                <mat-option *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
              </mat-select>
              <mat-error *ngIf="!formGroup.controls['MonedaId'].valid && formGroup.controls['MonedaId'].touched">
                {{ getErrorMoneda() }}
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Monto*</mat-label>
              <input type="number" matInput formControlName="Monto" (keyup.enter)="onGuardarPresupuesto()"
                maxlength="150" (change)="onMontoChange()">
              <mat-error *ngIf="!formGroup.controls['Monto'].valid && formGroup.controls['Monto'].touched">
                {{ getErrorMonto() }}
              </mat-error>
            </mat-form-field>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="!isAlicuotaIvaSearching">IVA{{tenantFeatureFlags?.HabilitarControlCaja ? "*" : ""}}</mat-label>
              <mat-label *ngIf="isAlicuotaIvaSearching">Cargando...</mat-label>
              <mat-select formControlName="AlicuotaIvaId">
                <mat-option *ngFor="let s of alicuotaIvaList" [value]="s.Id">{{s.Nombre}}</mat-option>
              </mat-select>
              <mat-error *ngIf="!formGroup.controls['AlicuotaIvaId'].valid && formGroup.controls['AlicuotaIvaId'].touched">
                {{ getErrorAlicuotaIva() }}
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item" style="margin-top: 15px; margin-bottom: 10px;">
            <mat-checkbox [(ngModel)]="itemPresupuesto.IncluyeFlete" [ngModelOptions]="{standalone: true}" color="primary">Incluye Flete
            </mat-checkbox>
          </div>

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Código de Presupuesto</mat-label>
              <input  matInput formControlName="Codigo" (keyup.enter)="onGuardarPresupuesto()" maxlength="100">
                <mat-error *ngIf="!formGroup.controls['Codigo'].valid && formGroup.controls['Codigo'].touched">
                  {{ getErrorCodigo() }}
                </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Fecha Vigencia</mat-label>
              <input matInput [matDatepicker]="fechaVigenciadPicker" formControlName="FechaVigencia"
                (click)="fechaVigenciadPicker.open()">
              <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVigenciadPicker">
              </mat-datepicker-toggle>
              <mat-datepicker-toggle style="display:inline-block;" matSuffix>
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #fechaVigenciadPicker></mat-datepicker>
              <mat-error *ngIf="!formGroup.controls['FechaVigencia'].valid && formGroup.controls['FechaVigencia'].touched">
                {{ getErrorFechaVigencia() }}
              </mat-error>
            </mat-form-field>
          </div>

          <div fxFlex=100 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Observación</mat-label>
              <input matInput formControlName="Observacion" (keyup.enter)="onGuardarPresupuesto()" maxlength="150">             
            </mat-form-field>
          </div>

          <div fxFlex=100 fxFlex.xs=100 class="flex-item">
 
            <mat-form-field appearance="outline" style="width: 100%" *ngIf="!(itemPresupuesto?.PresupuestoUrl != null && itemPresupuesto?.PresupuestoUrl.length > 0)">
              <mat-label class="text-style" *ngIf="comprobanteFile; else newFile">{{selectedFile}}</mat-label>
              <ng-template #newFile>
                <mat-label class="text-style">Adjuntar presupuesto</mat-label>
              </ng-template>
              <input matInput disabled>
              <button mat-icon-button matSuffix (click)="fileInput.click()">
                <mat-icon>attach_file</mat-icon>
              </button>
              <input hidden (change)="selectFile($event)" #fileInput type="file">
            </mat-form-field>

            <div class="zb-readonly" *ngIf="itemPresupuesto?.PresupuestoUrl != null && itemPresupuesto?.PresupuestoUrl.length > 0">
              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 15px;">
                    <a class="text-style" href="{{itemPresupuesto?.PresupuestoUrl}}" target="_blank">
                      Ver presupuesto adjunto
                    </a>
                    <a style="cursor: pointer; margin-right: 15px; margin-left: 18px;" (click)="deleteFile()">
                      <i class="fa fa-trash fa-1x"></i> 
                    </a>
                  </div>
                  
                </mat-expansion-panel>
              </div>
            </div>

          </div>

        </div>
      </form>

    </div>

  </ng-container>

  <ng-container *ngIf="!canEdit">

    <div fxLayout="row stretch" fxLayout.xs="column">
      <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true" style="margin:2vh 0">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label><b>Proveedor</b>: {{itemPresupuesto?.ProveedorNombre}}</mat-label>
            </div>
          </mat-expansion-panel>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true" style="margin:2vh 0">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label><b>Código Presupuesto</b>: {{itemPresupuesto?.Codigo}}</mat-label>
            </div>
          </mat-expansion-panel>
        </div>

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true" style="margin:2vh 0">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label><b>Forma de Pago</b>: {{itemPresupuesto?.FormaPagoNombre}}</mat-label>
            </div>
          </mat-expansion-panel>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true" style="margin:2vh 0">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label><b>Tipo de Compra</b>: {{itemPresupuesto?.TipoCompraNombre}}</mat-label>
            </div>
          </mat-expansion-panel>
        </div>

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true" style="margin:2vh 0">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label><b>Moneda</b>: {{itemPresupuesto?.MonedaNombre}}</mat-label>
            </div>
          </mat-expansion-panel>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true" style="margin:2vh 0">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label><b>Monto</b>: {{itemPresupuesto?.Monto | number:'1.2-2'}}</mat-label>
            </div>
          </mat-expansion-panel>
        </div>

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true" style="margin:2vh 0">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label><b>Fecha de Entrega</b>: {{itemPresupuesto?.FechaEntrega | date:'dd/MM/yyyy'}}</mat-label>
            </div>
          </mat-expansion-panel>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true" style="margin:2vh 0">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label><b>Fecha de Vigencia</b>: {{itemPresupuesto?.FechaVigencia | date:'dd/MM/yyyy'}}</mat-label>
            </div>
          </mat-expansion-panel>
        </div>

        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true" style="margin:2vh 0">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label><b>IVA</b>: {{itemPresupuesto?.AlicuotaIvaNombre}}</mat-label>
            </div>
          </mat-expansion-panel>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true" style="margin:2vh 0">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label><b>Incluye Flete</b>: {{itemPresupuesto?.IncluyeFlete ? 'Sí':'No'}}</mat-label>
            </div>
          </mat-expansion-panel>
        </div>

        <div fxFlex=100 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true" style="margin:2vh 0">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label><b>Observación</b>: {{itemPresupuesto?.Observacion}}</mat-label>
            </div>
          </mat-expansion-panel>
        </div>

        <div fxFlex=100 class="flex-item"
          *ngIf="itemPresupuesto?.PresupuestoUrl != null && itemPresupuesto?.PresupuestoUrl.length > 0">
          <mat-expansion-panel [expanded]="true" hideToggle="true" style="margin:2vh 0">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label><b>Presupuesto</b>: <a href="{{itemPresupuesto?.PresupuestoUrl}}" target="_blank">Presupuesto
                  Adjunto</a> </mat-label>
            </div>
          </mat-expansion-panel>
        </div>
      </div>
    </div>

  </ng-container>

</mat-expansion-panel>

<br />

<mat-expansion-panel [expanded]="true" *ngIf="itemPresupuesto != null">

  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon style="margin-top: -3px;">list</mat-icon> Detalle de Presupuesto
    </mat-panel-title>
    <mat-panel-description>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isDetalleSearching">
    <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
  </div>

  <ng-container *ngIf="canEdit && !esPrecargaPresupuestoDetalle">
    
    <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isPresupuestoDetalleSearching">
      <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    </div>

    <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isPresupuestoDetalleSearching && canEdit">
      <button mat-raised-button (click)="onNuevoDetalle()" color="primary" class="zb-button">Nuevo Detalle</button>
    </div>

    <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isPresupuestoDetalleSearching">

      <ejs-grid #detalleGrid [dataSource]='itemPresupuesto.PresupuestoDetalle' [toolbar]='toolbarOptions'
        [selectionSettings]='selectionOptions' [allowResizing]='true'>
        <e-columns>
          <e-column headerText='Pedido Item' width="25%"></e-column>
          <e-column headerText='Variante?' width="5%"></e-column>
          <e-column headerText='Material Alternativo' width="25%"></e-column>
          <e-column headerText='Detalle' width="15%"></e-column>
          <e-column headerText='Cantidad' width="15%"></e-column>
          <!-- <e-column headerText='Moneda'></e-column> -->
          <e-column headerText='Monto Unitario' width="15%"></e-column>
          <e-column headerText='Total' width="15%"></e-column>
          <e-column headerText='' *ngIf="canEdit" width="5%"></e-column>
          <e-column headerText='' *ngIf="canSelect" width="5%"></e-column>
        </e-columns>
        <ng-template #rowTemplate let-data>
          <tr class="e-row">
            <td class="e-rowcell" style="text-align: left; padding: 2px; margin: 0px;">
              <mat-select [(ngModel)]="data.PedidoItemId" name="PedidoItemId" (selectionChange)="onDetallePresupuestoChange(data.index, data.PedidoItemId, $event)" 
                style="padding: 4px 2px; width: 90%; border: 1px black solid;">
                <mat-option *ngFor="let s of pedidoItemList" [value]="s.Id">
                  {{s.MaterialNombre}} - {{s.Detalle?.length > 0 ? (s.Detalle+' -') : ''}} {{s.Cantidad | number:'1.2-2'}} {{s.MaterialUnidadMedida}}
                </mat-option>
              </mat-select>
            </td>
            <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
              <mat-checkbox [(ngModel)]="data.EsVariante" name="EsVariante" color="primary" title="Es una variante al material del pedido?"
                (change)="onDetallePresupuestoChange(data.index, data.PedidoItemId, $event)"></mat-checkbox>
            </td>
            <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
              <form [formGroup]="data.MaterialFormGroup" *ngIf="data.EsVariante">
                <!-- <mat-form-field appearance="outline" style="width: 100%"> -->
                <input type="text" placeholder="Material" aria-label="Material" matInput [matAutocomplete]="material"
                  formControlName="Material" style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                <i class="fa fa-spinner fa-spin" *ngIf="data.IsMaterialAutoSearching"></i>
                <!-- </mat-form-field> -->
                <mat-autocomplete #material="matAutocomplete" [displayWith]="displayMaterial" 
                  (optionSelected)="onDetallePresupuestoChange(data.index, data.PedidoItemId, $event)">
                  <mat-option *ngFor="let s of filteredMaterialList" [value]="s">
                    {{s.Nombre }}
                  </mat-option>
                </mat-autocomplete>
              </form>
            </td>
            <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
              <ng-container *ngIf="!data.EsVariante">{{data.Detalle}}</ng-container>
              <ng-container *ngIf="data.EsVariante">
                <input matInput type="text" maxlength="150" [(ngModel)]="data.Detalle" name="Detalle"
                  (change)="onDetallePresupuestoChange(data.index, data.PedidoItemId, $event)"
                  style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: right;">
              </ng-container>
            </td>
            <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
              <input matInput type="number" [(ngModel)]="data.Cantidad" name="Cantidad"
                (change)="onDetallePresupuestoChange(data.index, data.PedidoItemId, $event)"
                style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: right;">
            </td>
            <!-- <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
              <mat-select formControlName="Moneda">
                <mat-option *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
              </mat-select>
            </td> -->
            <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
              <input matInput type="number" [(ngModel)]="data.MontoUnitario" name="MontoUnitario"
                (change)="onDetallePresupuestoChange(data.index, data.PedidoItemId, $event)"
                style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: right;">
            </td>
            <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
              {{data.Total | number:'1.2-2'}}
            </td>
            <td class="e-rowcell" *ngIf="canEdit" style="text-align: center; padding: 3px 0px;">
              <a style="cursor: pointer;" (click)="deletePresupuestoDetalle(data)" title="Eliminar detalle del presupuesto">
                <mat-icon>delete</mat-icon>
              </a>
            </td>
            <td class="e-rowcell" *ngIf="canSelect" style="text-align: center; padding: 3px 0px;">
              <mat-checkbox [(ngModel)]="data.Seleccionado" name="Seleccionado" color="primary" title="Seleccionar presupuesto"
                (change)="selectPresupuestoDetalle(data.index, data.PedidoItemId, $event)"></mat-checkbox>
            </td>
          </tr>
        </ng-template>
      </ejs-grid>

    </div>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px; font-weight: bold;">
      <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="end end" class="flex-item">
        <mat-label>Monto Total: {{calculateMontoTotal() | number:'1.2-2'}}</mat-label>
      </div>
    </div>

  </ng-container>

  <ng-container *ngIf="!canEdit || esPrecargaPresupuestoDetalle">
    
    <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isPresupuestoDetalleSearching">
      <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    </div>

    <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isPresupuestoDetalleSearching">

      <ejs-grid #detalleGrid [dataSource]='itemPresupuesto.PresupuestoDetalle' [toolbar]='toolbarOptions'
        [selectionSettings]='selectionOptions' [allowResizing]='true' (actionFailure)="onGridActionFailure($event)">
        <e-columns>
          <e-column field='Material' headerText='Pedido'>
            <ng-template #template let-data>
              {{ data.PedidoItemMaterial }}
            </ng-template>
          </e-column>
          <e-column field='EsVariante' headerText='Variante?' *ngIf="!esPrecargaPresupuestoDetalle">
            <ng-template #template let-data>
              {{ data.EsVariante ? 'Sí' : 'No' }}
            </ng-template>
          </e-column>
          <e-column field='Material' headerText='Material Alternativo' *ngIf="!esPrecargaPresupuestoDetalle">
            <ng-template #template let-data>
              {{ data.MaterialNombre }}
            </ng-template>
          </e-column>
          <e-column field='Detalle' headerText='Detalle'></e-column>
          <e-column field='Cantidad' headerText='Cantidad'>
            <ng-template #template let-data>
              {{ data.Cantidad | number:'1.2-2' }}
            </ng-template>
          </e-column>
          <!-- <e-column field='MonedaNombre' headerText='Moneda'></e-column> -->
          <e-column field='MontoUnitario' headerText='Monto Unitario'>
            <ng-template #template let-data>
              {{ data.MontoUnitario | number:'1.2-2' }}
            </ng-template>
          </e-column>
          <e-column field='Total' headerText='Total'>
            <ng-template #template let-data>
              {{ data.Total | number:'1.2-2' }}
            </ng-template>
          </e-column>
          <e-column headerText='Selección' *ngIf="!esPrecargaPresupuestoDetalle">
            <ng-template #template let-data>
              <mat-checkbox *ngIf="canSelect" [(ngModel)]="data.Seleccionado" name="Seleccionado" color="primary" title="Seleccionar presupuesto"
                (change)="selectPresupuestoDetalle(data.index, data.PresupuestoDetalleId, $event)"></mat-checkbox>
              <ng-container *ngIf="!canSelect">{{ data.Seleccionado ? 'Sí' : 'No' }}</ng-container>
            </ng-template>
          </e-column>
        </e-columns>
      </ejs-grid>

    </div>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px; font-weight: bold;">
      <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="end end" class="flex-item">
        <mat-label>Monto Total: {{calculateMontoTotal() | number:'1.2-2'}}</mat-label>
      </div>
    </div>

  </ng-container>

</mat-expansion-panel>

<mat-card-actions style="margin-bottom: 20px;">
  <div fxLayout="row stretch" fxLayout.xs="column">
    <button mat-raised-button (click)="onGuardarPresupuesto()" color="primary" *ngIf="canEdit"
      class="zb-button">{{isSaving ? 'Guardando...' : (canSelect ? 'Guardar Presupuesto' : 'Guardar')}}</button>
    <button mat-raised-button (click)="onGuardarSeleccion()" *ngIf="canSelect"
      class="zb-button">{{isSavingSeleccion ? 'Guardando...' : 'Guardar Selección'}}</button>
    <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">
      {{data?.CanEditPresupuesto ? 'Cancelar' : 'Cerrar'}}
    </button>
  </div>
</mat-card-actions>
